import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';

interface DialogData {

}

@Component({
  selector: 'app-record-po-payment',
  templateUrl: './record-po-payment.component.html',
  styleUrls: ['./record-po-payment.component.scss']
})
export class RecordPoPaymentComponent implements OnInit {

  poData;
  amount = 0;
  payment_file;
  remainingAmount

  constructor(
    public dialogref: MatDialogRef<RecordPoPaymentComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private adminService: AdminService,
    private toastr: ToastrService
  ) { }

  private paymentfilesControl = new FormControl(null, FileUploadValidators.filesLimit(1));
  public demoForm = new FormGroup({
    files: this.paymentfilesControl
  });

  ngOnInit() {

    this.poData = this.data["data"];
    console.log(this.poData)
    this.paymentFile();
  }

  paymentFile() {
    const file = this.demoForm.get('files')
    file.valueChanges.subscribe(
      res => {
        this.payment_file = res[0]
        console.log(this.payment_file)
      }
    )
  }

  paidAmount(value) {
    if(value > this.poData.balance_due)
    {
     
    }
    else{
      this.remainingAmount = this.poData.balance_due - value;
    }
  }

  close() {
    return this.dialogref.close();
  }

  submitPayment() {
    let formData = new FormData();
    let invoice_amount = this.amount.toString()
    if(this.amount > this.poData.balance_due)
    {
      this.toastr.error('Paid Amount should not be greater then Balance Due', 'Error');
      return;
    }

    if (this.payment_file == null) {
      this.toastr.error('Please Submit proof of payment', 'Error');
    }
    else {
      formData.append('vendor_order_invoice_payment[amount]', invoice_amount)
      formData.append('vendor_order_invoice_payment[payment_file]', this.payment_file)
    
      this.adminService.createInvoicePayment(this.poData.id, formData).subscribe(
        res => {
          this.toastr.success('Your payment against the Invoice has been recorded', 'Success');
          this.close();
        },
        err => {
          this.toastr.error('Something went wrong', 'Error');
        }
      );
    }

  }

}
